import React, { Component } from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import Text from '@bit/knotchinc.web-react-components.text';
import { StepContainer, Title, CompleteLogo } from './styled.js';

class CompleteStep extends Component {
  render() {
    return (
      <StepContainer>
        <Box width="450px" margin="60px auto">
          <CompleteLogo />
          <Title>You’re all set!</Title>
          <Text fontSize="12px" color="#939AAB">
            Now it’s up to us. We’re generating your report - scraping, scanning,
            measuring. You’ll get an email in your inbox when it’s ready,
            and you can always find it in your Reports.
          </Text>
        </Box>
      </StepContainer>
    );
  }
}

CompleteStep.defaultProps = {
  name: 'Content Type',
};

export default CompleteStep;

